export enum ProspectPathEnum {
  prospect = 'prospect',
  activity = 'activity'
}
